















































import {Vue, Component, Prop} from 'vue-property-decorator'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {TokenPriced} from '@/model/resource/TokenPriced'
import {TextHelper} from '@/helpers/TextHelper'

type TokenPool = {
  token: TokenPriced
  amount: number
}

@Component({})
export default class OrbitRoundPoolSummary extends Vue {
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection

  get tokenPools(): TokenPool[] {
    const rawAmountByTokenId = new Map<number, number>()
    const tokenById = new Map<number, TokenPriced>()

    for (const orbitProject of this.orbitProjectCollection.items) {
      const token = orbitProject.tokenPriced
      const tokenId = token?.idTokenPricedPk
      const rawAmount = Number(orbitProject.amount || 0)

      if (!token || !tokenId || !rawAmount) continue

      tokenById.set(tokenId, token)
      rawAmountByTokenId.set(
        tokenId,
        (rawAmountByTokenId.get(tokenId) ?? 0) + rawAmount
      )
    }

    return Array.from(tokenById.entries()).map(([tokenId, token]) => ({
      token,
      amount:
        (rawAmountByTokenId.get(tokenId) ?? 0) /
        10 ** Number(token.decimals ?? 0),
    }))
  }

  get totalPoolFormatted(): string {
    if (this.tokenPools.length === 0) return 'N/A'

    return this.tokenPools
      .map(
        tokenPool =>
          `${TextHelper.formatAmount(tokenPool.amount)} ${
            tokenPool.token.symbol
          }`
      )
      .join(' + ')
  }

  get totalUsdFormatted(): string {
    const pricedTokenPools = this.tokenPools.filter(
      tokenPool => tokenPool.token.lastPriceStored
    )

    if (pricedTokenPools.length === 0) return 'N/A'

    const totalUsd = pricedTokenPools.reduce(
      (sum, tokenPool) =>
        sum + tokenPool.amount * Number(tokenPool.token.lastPriceStored),
      0
    )

    return totalUsd.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }
}
